import Login from "../log/Login";
import Register from "../log/Register";
import Area from "../pages/pages/Area/Area/Area";
import Collector from "../pages/pages/Collector/Collector/Collector";
import Customer from "../pages/pages/Customer/Customer/Customer";
import Payments from "../pages/pages/Customer/Payments/Payments";
import Dashboard from "../pages/pages/Dashboard/Dashboard/Dashboard";
import PrivateRoute from "./PrivateRoute";

const { createBrowserRouter } = require("react-router-dom");
const {
  default: DashboardLayout,
} = require("../Layouts/DashboardLayout/DashboardLayout");
const { default: Main } = require("../Layouts/Main");

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Main></Main>,
    errorElement: "",
    children: [
      {
        path: "/",
        element: <PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>,
        children: [
          {
            path: "/",
            element: <PrivateRoute><Dashboard></Dashboard></PrivateRoute>,
          },
          {
            path: "/dashboard",
            element: <PrivateRoute><Dashboard></Dashboard></PrivateRoute>,
          },
          {
            path: "/collector",
            element: <PrivateRoute><Collector></Collector></PrivateRoute>,
          },
          {
            path: "/customer",
            element: <PrivateRoute><Customer></Customer></PrivateRoute>,
          },
          {
            path: "/area",
            element: <PrivateRoute><Area></Area></PrivateRoute>,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login></Login>,
  },
  {
    path: "/register",
    element: <Register></Register>,
  },
  {
    path: "/payments/:id",
    element: <Payments></Payments>,
    loader : ({params})=>fetch(`https://amar-dish-server.vercel.app/customer/${params.id}`)
  },
]);
